export const isSearchFilterExperienceEnabled = initData =>
    initData &&
    initData.splitTests &&
    initData.splitTests['search-filter-experience'] === true &&
    initData.featureSwitches &&
    initData.featureSwitches['search-filter-experience'] === true;

export const isBrowseFilterExperienceEnabled = initData =>
    initData &&
    initData.featureSwitches &&
    initData.featureSwitches['browse-filter-experience'] &&
    initData.discoverEnabled;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/utils/enabled-features.js